export const CHANGE_SEARCH_FIELD='CHANGE_SEARCH_FIELD';

export const REQUEST_ROBOTS_PENDING='REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCESS='REQUEST_ROBOTS_SUCCESS';
export const REQUEST_ROBOTS_FAILED='REQUEST_ROBOTS_FAILED';

